import { render, staticRenderFns } from "./superiors_table.vue?vue&type=template&id=6ebb07a4&"
import script from "./superiors_table.vue?vue&type=script&lang=js&"
export * from "./superiors_table.vue?vue&type=script&lang=js&"
import style0 from "./superiors_table.vue?vue&type=style&index=0&id=6ebb07a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports